export const INVALID_PHONE_NUMBER_ERROR= 'invalidPhoneNumber';

export const INVALID_COUNTRY_CODE_ERROR = 'invalidCountryCode';